import React from 'react';

/**
 * Auth/User 情報を配るコンテキスト
 * - user: CognitoUser | null
 * - isLoaded: 初期化完了フラグ
 * - updateCurrentUser: App側で実装される更新関数
 */
const UserContext = React.createContext({
  user: null,
  currentUser: null,
  isLoaded: false,
  // デフォルトは no-op。App 側の Provider で本物が入る前提
  updateCurrentUser: () => {}
});

export default UserContext;